module.exports = "https://cdn.hellotech.com/client-assets/hubs_and_speakers_mobile_03c23f41274e7bda06f675d26c5cc42d.png";